import { render, staticRenderFns } from "./OutboxMessageContent.vue?vue&type=template&id=5ebeeb82&scoped=true"
import script from "./OutboxMessageContent.vue?vue&type=script&lang=js"
export * from "./OutboxMessageContent.vue?vue&type=script&lang=js"
import style0 from "./OutboxMessageContent.vue?vue&type=style&index=0&id=5ebeeb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebeeb82",
  null
  
)

export default component.exports